// Bouton retour en haut de page
let showOnPx = 600;
let is_sticky = false;
let backToTopButton = document.getElementById("back-to-top");
let footer = document.querySelector('footer');

const scrollContainer = () => {
    return document.documentElement || document.body;
};

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) ||
          (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

document.addEventListener("scroll", () => {
    // console.log('Scroll de la page : ' + scrollContainer().scrollTop + ' - Footer top: ' + footerTop + ' TOTO: ' + toto);

    if (scrollContainer().scrollTop > showOnPx) {
        backToTopButton.classList.remove("hidden")
    } else {
        backToTopButton.classList.add("hidden")
    }
    if( elementIsVisibleInViewport(footer, true) ) {
        // console.log('Has reached footer!');
        backToTopButton.classList.add('back-to-top--static');
    } else {
        // console.log('Footer not reached');
        // backToTopButton.classList.remove('back-to-top--static');
    }
});

const goToTop = () => {
    document.body.scrollIntoView({
        behavior: "smooth",
    });
};

backToTopButton.addEventListener("click", goToTop)